import { useState } from 'react'

const useAnchor = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleOpen = (event) => {
    if (!open) {
      setAnchorEl(event.currentTarget)
      event.currentTarget.blur()
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return { anchorEl, open, handleOpen, handleClose }
}

export default useAnchor
